/// <reference types="vite/client" />

interface AdminEnv {
  readonly VITE_API_URL?: string;
  readonly VITE_FLEET_TIMEZONE?: string;
  readonly VITE_MAP_TILES?: string;
  readonly VITE_MAP_GLYPHS?: string;
  readonly VITE_MAP_SEARCH?: string;
  readonly VITE_WEBSITE_URL?: string;
}

const raw = import.meta.env as unknown as AdminEnv;
const clean = (value: string | undefined) => (value ?? '').trim();

/** Build-time settings (.env.example). None of them is secret: they ship in the JavaScript. */
export const env = {
  /** '' = the API is on the app's own origin (the dev proxy, or one Nginx host). */
  apiUrl: clean(raw.VITE_API_URL).replace(/\/+$/, ''),
  /** The zone of the API's wall-clock times (its APP_TIMEZONE). */
  fleetZone: clean(raw.VITE_FLEET_TIMEZONE) || 'Asia/Riyadh',
  /** OpenMapTiles-schema vector tiles (TileJSON) and their glyphs. */
  mapTiles: clean(raw.VITE_MAP_TILES) || 'https://tiles.openfreemap.org/planet',
  mapGlyphs: clean(raw.VITE_MAP_GLYPHS) || 'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf',
  /** A Photon place search (OpenStreetMap) for the standard map's search box; Google Maps searches Google's places. */
  mapSearch: clean(raw.VITE_MAP_SEARCH).replace(/\/+$/, '') || 'https://photon.komoot.io/api',
  /** The public website — where a new company registers (linked from the sign-in page). */
  websiteUrl: clean(raw.VITE_WEBSITE_URL).replace(/\/+$/, '') || 'https://vlm.viganium.com',
} as const;

/** Makkah, at the Haram, [lng, lat] — every map's view before the fleet, a trip or a geofence gives one (operator, 2026-10-25; Riyadh until then, the old admin's default). */
export const DEFAULT_CENTER: [number, number] = [39.8262, 21.4225];
